import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getTopics = async (search?: string) => {
  const { data, error } = await supabase
    .from('playlists')
    .select('*')
    .eq('type', 'topics')
    .gte('topic_id', 0)

  if (error) {
    throw new Error(error.message)
  }

  const ids = data?.map((d) => d?.topic_id)
  const playlistIds = data?.map((d) => d?.id)

  let req = supabase
    .from('topics')
    .select('*')
    .in('id', ids)

  if (search) {
    req = req.or(
      `name.ilike.%${search}%`,
    )
  }

  const { data: topics } = await req.range(0, 100)

  return topics?.map((el, i) => ({ ...el, ...{ playlistId: playlistIds[i] } }))
}

export default function useTopics(search?: string) {
  return useQuery({
    queryKey: ['useTopics', search],
    queryFn: () => getTopics(search),
    staleTime: 60000,
  })
}
